import { Component, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { AppComponent } from '@/app.component';
import Player from 'video.js/dist/types/player';
import { WebrtcService } from '@services/webrtc.service';
import { WowzaConfig } from '@/Common/wowza-config.model';
import videojs from 'video.js';

@Component({
  selector: 'app-webrtcfeeds',
  templateUrl: './webrtcfeeds.component.html',
  styleUrls: ['./webrtcfeeds.component.scss']
})
export class WebrtcfeedsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  public currentScreen: 'WebrtcfeedsScreen' | 'AccessDeniedScreen' | 'WebrtcfeedsErrorScreen' = 'WebrtcfeedsScreen';
  public year = new Date().getFullYear();
  public version : string = "";
  
  public streamName: string = "";
  public applicationName: string = "";
  public wssUrl: string = "";
  public TokenExpiryTime: string = "";
  public LocalExpiryDate: Date = new Date();

  public prefix: string = "";
  public SharedKey: string = "";
  public wowzatimeout: number = 1440; // seconds
  public isIp: boolean = false;
  public ip: string = "";
  public siteCompany: string = "";

  public videoFormat = "";

  videoElement: HTMLVideoElement | null = null;
  player: Player | undefined;
  timeout: ReturnType<typeof setTimeout> | null = null;

  public selectedWowzaConfig: WowzaConfig;
  private retryInterval = 8000; // retry every 8 seconds
  private maxRetries = 5; // max retry attempts
  private retryCount = 0;

  options = {
    liveui: true,
    autoplay: true,
    controlBar: { pictureInPictureToggle: false },
    plugins: { reloadSourceOnError: {} }
  };

  constructor(private app: AppComponent, private webrtcService: WebrtcService) {
    this.currentScreen = this.app.getAttribute("screen");
    this.year = new Date().getFullYear();

     this.wssUrl = window["wssUrl"];
     this.streamName = window["streamName"];
     this.applicationName = window["applicationName"];
     this.TokenExpiryTime = window["TokenExpiryTime"];
     this.SharedKey = window["SharedKey"];
     this.prefix = window["prefix"];
     this.wowzatimeout = window["wowzatimeout"];
     this.isIp = false;
    this.ip = '127.0.0.1';

    this.version = window["version"];
    this.siteCompany = window["siteCompany"];

    // this.wssUrl = "wss://media-server-trial2.mview.com.au:443/webrtc-session.json";
    // this.streamName = "BWV";
    // this.applicationName = "bwvdemo";
    // this.TokenExpiryTime = '6/27/2026 1:24:36 PM';
    // this.prefix = 'wowzatoken';
    // this.SharedKey = 'bwvdemosharedsecretkey';
    // this.wowzatimeout = 1440; // seconds
    // this.isIp = false;
    // this.ip = '127.0.0.1';

    this.LocalExpiryDate = new Date(this.TokenExpiryTime + ' UTC');
    // console.log(this.LocalExpiryDate);
    // console.log('constructor');
    // console.log('currentScreen ' + this.currentScreen);
    // console.log('streamName ' + this.streamName);
    // console.log('applicationName ' + this.applicationName);
    // console.log('wssUrl ' + this.wssUrl);

    this.selectedWowzaConfig = {
      streamName: this.streamName,
      applicationName: this.applicationName,
      wssUrl: this.wssUrl,
      prefix: this.prefix,
      sharedKey: this.SharedKey,
      wowzaTimeout: this.wowzatimeout,
      isIp: this.isIp,
      ip: this.ip
    };


  }

  ngOnInit(): void {
    this.initVideoPlayer();
  }

  ngAfterViewInit(): void {
    if(this.currentScreen == 'WebrtcfeedsScreen'){
      this.videoElement = document.getElementById("player-video") as HTMLVideoElement | null;
      this.subscribeToWebrtcEvents();
      if (this.videoElement) this.loadStream();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.stopStream();
  }

  ngOnDestroy(): void {
    this.stopStream();
    if (this.player) this.player.dispose();
    if (this.timeout) clearTimeout(this.timeout);
  }

  private initVideoPlayer(): void {
    const video = document.getElementById("player-video") as HTMLVideoElement | null;
    if (!video) return;

    video.muted = true;
    video.setAttribute("muted", ""); 
    video.setAttribute("playsinline", "");

    this.player = videojs(video, this.options, () => {
      console.log("Video.js player initialized");
    });

    this.player.muted(true);

    this.player.on('error', () => {
      const err = this.player?.error()?.message || "Unknown video.js error";
      console.error("Video.js error:", err);
      this.handleError(err);
    });
  }

  private subscribeToWebrtcEvents(): void {
    this.webrtcService.streamError.subscribe(errMsg => {
      console.error("WebRTC stream error:", errMsg);
      this.handleError(errMsg.includes("502") ? "Stream is offline" : errMsg);
    });

    this.webrtcService.codecInfo.subscribe(codec => {
      console.log("Stream codec:", codec);
      this.videoFormat = codec;
    });
  }

  private stopStream(): void {
    this.webrtcService.stop();
    
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.srcObject = null;
      this.videoElement.load();
    }

    if (this.timeout) clearTimeout(this.timeout);
    this.retryCount = 0;
  }

  public initilizeStreamed(): void {
    this.stopStream();
    setTimeout(() => this.loadStream(), 300);
  }
  
  private loadStream(): void {
    if (!this.videoElement) return;

    // Update the config
    this.selectedWowzaConfig.streamName = this.streamName;

    this.webrtcService.loadStream(this.videoElement, this.selectedWowzaConfig)
      .then(() => {
        console.log("WebRTC stream started");
        
        if (this.videoElement) {
          this.videoElement.muted = true;
        }
        this.retryCount = 0; // reset retry counter
      })
      .catch(err => {
        const errorMsg = err?.message || "Failed to start stream";
        console.error(errorMsg);
        this.handleError(errorMsg);
      });
  }

  private handleError(error: string | null = null): void {
    console.error("Streaming error:", error);

    if (this.retryCount >= this.maxRetries) {
      console.error("Max retry attempts reached. Giving up.");
      return;
    }

    if (this.timeout) clearTimeout(this.timeout);

    this.retryCount++;
    console.log(`Retrying stream (${this.retryCount}/${this.maxRetries}) in ${this.retryInterval / 1000}s...`);

    this.timeout = setTimeout(() => {
      this.timeout = null;
      this.loadStream();
    }, this.retryInterval);
    
  }

  log($event: any): void {
    console.log($event);
  }
}